export default __webpack_public_path__ + "static/media/home-2.d52e359c.jpg";